<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

import type { MenuItems } from "@/types/menu";

import { useComponentErrorCapture } from "@/mixins/error";
import { useMenuItems } from "@/mixins/menuItems";

import { appStateStore } from "@/stores/appState";

import MenuProfile from "@/components/profile/MenuProfile.vue";

const props = defineProps({
  onSubPage: {
    type: Boolean,
    default: false,
  },
});

const { t } = useTranslation();
useComponentErrorCapture();
const router = useRouter();
const appState = appStateStore();

const { getMenuItems } = useMenuItems();
const items = getMenuItems() as MenuItems || [];
const open = ref(false);

defineExpose({
  isActive,
});

const showMobileMenu = computed(() => {
  return router.currentRoute.value.name !== "login";
});

function isActive() {
  return open.value;
}

</script>
<template>
  <div v-if="showMobileMenu" class="menu-main-mobile">
    <Teleport to="body">
      <Transition name="opacity">
        <div v-show="open && onSubPage" class="menu-main-mobile__top-line">
          <router-link :to="{ name: 'home' }">
            <img alt="Unfolded Circle logo" class="logo" src="/logo.svg" width="45" height="30" />
          </router-link>
        </div>
      </Transition>
      <button class="menu-main-mobile__trigger" @click="open = !open" :class="{'active': open, 'menu-main-mobile__trigger--in-background': appState.activeDropdown}">
        <div class="line"></div>
        <div class="line"></div>
      </button>
      <Transition name="opacity">
        <div v-show="open" class="menu-main-mobile__body">
          <ul class="menu-main-mobile__items">
            <li v-for="item in items" class="menu-main-mobile__item">
              <router-link :to="item.to" @click="open = false">{{ $t(item.title) }}</router-link>
            </li>
          </ul>
          <div class="menu-main-mobile__profiles">
            <MenuProfile
              @logout="open = false"
              :mobile-view="true"/>
          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>